// ======================================================================
// File: QARoutes.js
// Module: PPE → Quality → Incoming QA
// Purpose: Routing configuration
// ======================================================================

import React from "react";
import { Routes, Route } from "react-router-dom";

import QAInspectionPage from "./pages/QAInspectionPage";
import QAInspectionDetailPage from "./pages/QAInspectionDetailPage";

export default function QARoutes() {
  return (
    <Routes>
      <Route path="/incoming" element={<QAInspectionPage />} />
      <Route path="/incoming/:id" element={<QAInspectionDetailPage />} />
    </Routes>
  );
}